import { axios } from "~/plugins/request"
export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	findMenuCatalog({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`menu/findMenuCatalog`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`menu/save`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`menu/findById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  delete({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`menu/delete`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findMenuByParentId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`menu/findMenuByParentId`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findMenuTree() {
    return new Promise((resolve, reject) => {
      axios.get(`menu/findMenuTree`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  
}
